import axios, { AxiosResponse } from "axios";
import { setupCache } from "axios-cache-adapter";

class BaseDAO {
  protected baseAPIPath: string = process.env.REACT_APP_URL_API ? process.env.REACT_APP_URL_API : "http://oba-webapp-api.azurewebsites.net/";
  protected getAPIPath(): string {
    return this.baseAPIPath;
  }
  
  private static cache: any = setupCache({
    maxAge: 10 * 60 * 1000,
    exclude: {
      paths: [],
      query: false,
      filter: (req: any) => {
        if (req.url.indexOf("/Basket") !== -1) return true;
        if (req.url.indexOf("/ClientAddress?ClientID") !== -1) return true;
        if (req.url.indexOf("/ClientShopList?ClientID=") !== -1) return true;
        if (req.url.indexOf("/Freight?ZipCode=") !== -1) return true;
        if (req.url.indexOf("/loop-destaques") !== -1) return true;
        if (req.url.indexOf("/DeliveryWindowOption") !== -1) return true;
        if (req.url.indexOf("/SaleHistory?") !== -1) return true;
        if (req.url.indexOf("storeOffers") !== -1) return true;
        if (req.url.indexOf("getByAddress") !== -1) return true;
      },
    },
  });

  private static api = axios.create({
    adapter: BaseDAO.cache.adapter,
    timeout: 90 * 1000, // 60s
  });

  public get(
    key: string,
    url: string,
    config: any
  ): Promise<AxiosResponse<any>> {
    return BaseDAO.api.get(url, config);
  }

  public post(
    url: string,
    body: any,
    config: any
  ): Promise<AxiosResponse<any>> {
    return BaseDAO.api.post(url, body, config);
  }

  public patch(
    url: string,
    body: any,
    config: any
  ): Promise<AxiosResponse<any>> {
    return BaseDAO.api.patch(url, body, config);
  }

  public put(url: string, body: any, config: any): Promise<AxiosResponse<any>> {
    return BaseDAO.api.put(url, body, config);
  }

  public delete(
    url: string,
    body: any,
    config: any
  ): Promise<AxiosResponse<any>> {
    config.data = body;
    return axios.delete(url, config);
  }
}

export default BaseDAO;
